<pct-form-autocomplete
  class="list-filter-form-field"
  fullWidth="true"
  multiple="true"
  nameAttribute="category-ids"
  [extraParameters]="{ languageCodes: ['hu', 'en'] }"
  [formControl]="control()"
  [inputService]="service()"
  [label]="{ text: label(), translate: false }"
  [searchControlValidators]="SEARCH_TEXT_MAX_LENGTH_VALIDATOR"
/>
